import { __awaiter, __generator } from "tslib";
import { getCachedModule, getScalprum } from '@scalprum/core';
export function loadComponent(scope, module, importName) {
    if (importName === void 0) { importName = 'default'; }
    return __awaiter(this, void 0, void 0, function () {
        var pluginStore, mod, cachedModule;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pluginStore = getScalprum().pluginStore;
                    mod = void 0;
                    cachedModule = getCachedModule(scope, module).cachedModule;
                    mod = cachedModule;
                    if (!!mod) return [3 /*break*/, 2];
                    return [4 /*yield*/, pluginStore.getExposedModule(scope, module)];
                case 1:
                    mod = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, {
                        prefetch: mod.prefetch,
                        component: mod[importName],
                    }];
            }
        });
    });
}
//# sourceMappingURL=async-loader.js.map